<template>
  <div class="page_diaobo_wl_index">
    <Add
      v-if="showAdd"
      :showType="showType"
      :showData="showData"
      :emmList="myEmmList"
      @close="addClose"
      @addComfirm="addComfirm"
      @addChange="addChange"
    ></Add>
    <div class="list_page" v-else>
      <van-nav-bar
        title="物流装车记录"
        :right-text="type === 3 ? '' : '新增'"
        @click-left="onClickLeft"
        @click-right="showAddClick(1)"
      >
      <template #left>
        <van-icon size="22px" name="arrow-down"></van-icon>
      </template>
      </van-nav-bar>
      <div class="list_box">
        <div
          class="box"
          v-for="(row, index) in myList"
          :key="index"
          @click="showAddClick(type === 3 ? 3 : 2, row, index)"
        >
          <van-cell value="查看详情" :title="row.classificationName" is-link>
          </van-cell>
          <div class="other">
            <p>
              司机姓名：<span>{{ row.driver }}</span>
            </p>
            <p>
              联系电话：<span>{{ row.phone }}</span>
            </p>
            <p>
              车牌号：<span>{{ row.plateNumber }}</span>
            </p>
            <p>
              运输车型：<span>{{ row.carModel }}</span>
            </p>
            <p>
              装车单号：<span>{{ row.logisticsNumber }}</span>
            </p>
            <p>
              物流公司：<span>{{ row.logisticsCompany }}</span>
            </p>
          </div>
        </div>
        <van-empty v-if="myList.length < 1" description="列表为空" />
      </div>
    </div>
  </div>
</template>
<script>
import Add from "./wl_add.vue";
export default {
  components: { Add },
  props: ["value", "emmList", "type"],
  watch: {
    value() {
      this.myList = this.value && this.value.length > 0 ? this.value : [];
    },
    emmList() {
      this.myEmmList = this.emmList;
      console.log("wlindex", this.myEmmList);
    },
  },
  data() {
    return {
      myList: [],
      myEmmList: [],
      showAdd: false,
      showType: 1, //0直接新增,1列表新增,2编辑,3查看
      showData: {},
    };
  },
  created() {
    this.myList = this.value && this.value.length > 0 ? this.value : [];
    this.myEmmList = this.emmList;
  },
  methods: {
    onClickLeft() {
      this.$emit("wlPageClose");
    },
    showAddClick(type, row, index) {
      console.log("aaa", type, row, index);
      if (this.disabled && type < 2) {
        //查看模式下不允许点击新建
        return;
      }
      this.showType = type;
      if (type > 1 && row) {
        this.showData = row;
        this.showData.changeIndex = index;
      }
      this.showAdd = true;
    },
    addComfirm(data) {
      this.myList.push(data);
      console.log("aa", data, this.myList);
      this.$emit("input", this.myList);
    },
    addChange(data) {
      this.myList[data.changeIndex] = data;
      this.myList.splice(0, 0);
      console.log("bb", data, this.myList);
      this.$emit("input", this.myList);
    },
    addClose() {
      this.showAdd = false;
    },
  },
};
</script>
<style lang="scss">
.page_diaobo_wl_index {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  .list_page {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .van-nav-bar {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    .list_box {
      width: 100%;
      height: calc(100% - 44px);
      overflow-x: hidden;
      overflow-y: auto;
      background-color: #f6f8f9;
      .other {
        background-color: #fff;
        padding: 5px 10px 16px 10px;
        margin-bottom: 10px;
        font-size: 14px;
        p {
          color: rgb(153, 154, 160);
          margin: 5px 0;
          span {
            color: rgb(90, 91, 94);
          }
        }
      }
    }
  }
}
</style>